export var formatAddress = function formatAddress(_ref, locale) {
  var street1 = _ref.street1,
      street2 = _ref.street2,
      city = _ref.city,
      region = _ref.region,
      postalCode = _ref.postalCode;

  if (locale.toLowerCase() === 'ja-jp') {
    return "".concat(postalCode, " ").concat(region).concat(city).concat(street1).concat(street2);
  }

  return [street1, street2, city, region, postalCode].filter(Boolean).join(', ');
};